import { render, staticRenderFns } from "./doctorList.vue?vue&type=template&id=5a1d5a6a&scoped=true"
import script from "./doctorList.vue?vue&type=script&lang=js"
export * from "./doctorList.vue?vue&type=script&lang=js"
import style0 from "./doctorList.vue?vue&type=style&index=0&id=5a1d5a6a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1d5a6a",
  null
  
)

export default component.exports